import { InretrnWidgetContent } from "./inreturn-widget-content";
import { getInreturnCredentials } from "../../../utils/get-inreturn-credentials";

export const InretrnWithdrawWidget = () => {
  const { inretrnUrl, inretrnToken } = getInreturnCredentials();

  return (
    <InretrnWidgetContent
      scriptUrl={inretrnUrl}
      token={inretrnToken}
      returnType="withdrawal"
    />
  );
};
